import $http from '../../axios'

export default {

    /* ===========================
       VERIFICAR STATUS
    ============================ */
    async checkWhatChimpStatus({ commit }) {
        try {
            const response = await $http.get('/api/whatchimp/status')
            if (response.data.connected) {
                commit('SET_WHATCHIMP_AUTH', response.data)
            } else {
                commit('SET_WHATCHIMP_AUTH', null)
            }
        } catch (error) {
            commit('SET_WHATCHIMP_AUTH', null)
        }
    },

    /* ===========================
       CONECTAR WHATCHIMP
    ============================ */
    async connectWhatChimp({ commit }, payload) {
        commit('SET_WHATCHIMP_CONNECTING', true)
        commit('SET_WHATCHIMP_ERROR', null)

        try {
            const response = await $http.post('/api/whatchimp/connect', {
                api_token:         payload.api_token,
                phone_number_id:   payload.phone_number_id,
                whatchimp_webhook: payload.whatchimp_webhook,
                meta_token:        payload.meta_token,
                waba_id: payload.waba_id,
            })

            commit('SET_WHATCHIMP_AUTH', response.data)

            return response.data

        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) 
                ? error.response.data.message 
                : 'Error conectando WhatChimp'
            commit('SET_WHATCHIMP_ERROR', message)
            throw error
        } finally {
            commit('SET_WHATCHIMP_CONNECTING', false)
        }
    },

    /* ===========================
       DESCONECTAR WHATCHIMP
    ============================ */
    async disconnectWhatChimp({ commit }) {
        try {
            await $http.delete('/api/whatchimp/disconnect')
            commit('SET_WHATCHIMP_AUTH', null)
        } catch (error) {
            console.error('Error desconectando WhatChimp', error)
        }
    },

    async fetchWhatsappTemplates({ commit }) {
    try {
        const response = await $http.get('/api/whatsapp-templates/list')
        commit('SET_WHATCHIMP_TEMPLATES', response.data.data || [])
    } catch (error) {
        console.error('Error cargando templates WhatsApp', error)
    }
    },

    async fetchWhatsappVariables({ commit }) {

    try {

        const response = await $http.get('/api/whatsapp-templates/variables')

        commit(
            'SET_WHATCHIMP_VARIABLES',
            response.data.data || []
        )

    } catch (error) {

        console.error(
            'Error cargando variables WhatsApp',
            error
        )

    }

},

}


// WEBPACK FOOTER //
// ./src/modules/whatChimpApi/actions.js